import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaBullhorn,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BusinessVideoMarketingInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Business Video Marketing in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Drive Your Brand Forward</Subheading>}
        heading={
          <Heading>
            Business <span tw="text-primary-500">Video Marketing</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide business video marketing in **DIFC**,
            creating compelling videos that boost brand visibility, engage
            audiences, and drive conversions. Elevate your marketing strategy
            with our expert video solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?w=800&auto=format&fit=crop&q=60", // Team meeting
          "https://images.pexels.com/photos/3182746/pexels-photo-3182746.jpeg?w=800&auto=format&fit=crop&q=60", // Video production
          "https://images.pexels.com/photos/3184297/pexels-photo-3184297.jpeg?w=800&auto=format&fit=crop&q=60", // Professional visuals
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Campaign"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Video Marketing in DIFC"
        description="We craft videos that power your marketing strategy."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Visuals",
            description: "High-quality videos that capture attention.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Results",
            description: "Trusted by DIFC businesses for success.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Targeted Storytelling",
            description: "Content that resonates with your audience.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Execution",
            description: "Quick delivery to meet campaign deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Optimized",
            description: "Videos tailored for social media and web.",
          },
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Marketing Impact",
            description: "Designed to boost conversions and reach.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Video Marketing Process"
        description={
          <Description>
            We create impactful video marketing campaigns with a strategic
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your marketing objectives.</li>
              <li>Strategy: Develop targeted video concepts.</li>
              <li>Filming: Capture with professional equipment.</li>
              <li>Editing: Enhance visuals and audio for impact.</li>
              <li>Distribution: Optimize for campaign platforms.</li>
              <li>Support: Provide ongoing campaign assistance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1504465039710-0f49c0a47eb7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1522152716425-ec958d91dbf2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
          "https://images.unsplash.com/photo-1581591524425-c7e0978865fc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Video production planning meeting
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Video Marketing Wins in DIFC"
        description="Our videos have driven marketing success in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High Engagement",
            description: "Boosted campaign performance with videos.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Increased Reach",
            description: "Expanded visibility for DIFC brands.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Approval",
            description: "96% satisfaction from marketing campaigns.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Video Marketing?</Subheading>}
        heading="Business Video Marketing in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for business video marketing in DIFC.
            Create powerful, engaging videos that drive your brand
            forward—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1513759565286-20e9c5fad06b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai business district skyline
          "https://images.unsplash.com/photo-1528109966604-5a6a3a443625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional videographer with equipment
          "https://images.unsplash.com/photo-1569159316193-42ecbf194bad?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Corporate video interview setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
